import { CustomFieldTypeName } from '@air/api/types';
import { CalendarDaysIcon, SelectDropdownInputIcon, TextCursorInputIcon } from '@air/design-icons';

export const customFieldIconMap: Record<CustomFieldTypeName, typeof SelectDropdownInputIcon> = {
  [CustomFieldTypeName.singleSelect]: SelectDropdownInputIcon,
  [CustomFieldTypeName.multiSelect]: SelectDropdownInputIcon,
  [CustomFieldTypeName.plainText]: TextCursorInputIcon,
  [CustomFieldTypeName.date]: CalendarDaysIcon,
};
